export default __webpack_public_path__ + "static/media/dotted.2bc7caf2.svg";